import React, { useState, useEffect } from 'react';

export default function StatusCard() {
  const [startTime, setStartTime] = useState(null);
  const [currentTime, setCurrentTime] = useState(Date.now());
  const [isRunning, setIsRunning] = useState(false);

  // อัปเดตเวลาปัจจุบันทุกวินาที
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(Date.now());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // โหลดสถานะการฟักไข่จาก backend
  useEffect(() => {
    fetch('https://projecteggincubator.com/api/get_incubation.php')
      .then(res => res.json())
      .then(data => {
        if (data.start_time && data.is_running) {
          setStartTime(new Date(data.start_time).getTime());
          setIsRunning(true);
        }
      })
      .catch(err => console.error("Failed to fetch incubation status:", err));
  }, []);

  // เริ่มฟักไข่
  const handleStart = () => {
    if (!startTime) {
      const now = new Date().toISOString();
      setStartTime(Date.now());
      setIsRunning(true);

      // บันทึกเวลาเริ่มไปยัง backend
      fetch('https://projecteggincubator.com/api/set_incubation.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `start_time=${encodeURIComponent(now)}&is_running=true`
      });
    }
  };

  // รีเซ็ตการฟักไข่
  const handleReset = () => {
    setStartTime(null);
    setIsRunning(false);

    fetch('https://projecteggincubator.com/api/set_incubation.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: `start_time=&is_running=false`
    });
  };

  // แสดงวันเวลา ณ ปัจจุบัน
  const today = new Date(currentTime);
  const todayStr = today.toLocaleDateString('th-TH');
  const timeStr = today.toLocaleTimeString('th-TH', { hour12: false });

  // คำนวณจำนวนวันที่ฟักไข่
  let daysIncubated = 0;
  if (startTime && isRunning) {
    const diffMilliseconds = currentTime - startTime;
    daysIncubated = Math.floor(diffMilliseconds / (1000 * 60 * 60 * 24));
  }

  return (
    <div className="status-bar" style={{ background: 'white', padding: '1.5rem', borderRadius: '12px', textAlign: 'center', border: '5px solid black' }}>
      <div>📅 วันที่: {todayStr}</div>
      <div>🕒 เวลา: {timeStr}</div>
      <div>🥚 ฟักไข่ได้: {daysIncubated} วัน</div>

      <div style={{ marginTop: '0.5rem', display: 'flex', justifyContent: 'center', gap: '1rem' }}>
        <button
          onClick={handleStart}
          style={{
            ...buttonStyle,
            background: isRunning ? '#888' : '#28a745',
            cursor: isRunning ? 'default' : 'pointer'
          }}
          disabled={isRunning}
        >
          {isRunning ? 'กำลังฟักไข่...' : 'เริ่มฟักไข่'}
        </button>

        <button onClick={handleReset} style={{ ...buttonStyle, background: '#dc3545' }}>
          รีเซ็ต
        </button>
      </div>
    </div>
  );
}

const buttonStyle = {
  padding: '0.5rem 1rem',
  color: 'white',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  fontSize: '14px',
  fontWeight: 'bold',
  minWidth: '120px'
};
